import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {
    Input,
    Select
} from '../../../../../../../_metronic/_partials/controls';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../../../_metronic/_partials/controls';
import { RoleChecker, RoleCheckerNoRedux } from '../../../../../../RoleChecker';
import { copyValue } from "../../../../../../../_metronic/_helpers/UtilityHelpers";
import { categoryPeriode, tipePeriode } from '../PeriodeKurbanUIHelpers';
import CurrencyInput from 'react-currency-input-field';





export function PeriodeKurbanEditForm({ savePeriodeKurban, actionsLoading, periodeKurban, roleMaster, onHide, id }) {
    const yupShape = {
        name: Yup.string()
            .min(3, 'Minimum 3 symbols')
            .max(50, 'Maximum 50 symbols')
            .required('Nama Periode Kurban Wajib Diisi'),
        target_sapi: Yup.number().min(1, "Target Tidak Boleh Kurang Dari Sama Dengan 0").required('Target wajib diisi'),
        target_fr_sapi: Yup.number().min(1, "Target Tidak Boleh Kurang Dari Sama Dengan 0").required('Target wajib diisi'),
        target_kambing: Yup.number().min(1, "Target Tidak Boleh Kurang Dari Sama Dengan 0").required('Target wajib diisi'),
        target_fr_kambing: Yup.number().min(1, "Target Tidak Boleh Kurang Dari Sama Dengan 0").required('Target wajib diisi'),
        target_17_sapi: Yup.number().min(1, "Target Tidak Boleh Kurang Dari Sama Dengan 0").required('Target wajib diisi'),
        target_fr_17_sapi: Yup.number().min(1, "Target Tidak Boleh Kurang Dari Sama Dengan 0").required('Target wajib diisi'),
    }

    if (id) {
        yupShape.kurban_number_prefix = Yup.number().min(1, "Target Tidak Boleh Kurang Dari Sama Dengan 0").required('Target wajib diisi')
    }

    // Validation schema
    const PeriodeKurbanEditSchema = Yup.object().shape(yupShape);
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={periodeKurban}
                validationSchema={PeriodeKurbanEditSchema}
                onSubmit={(values) => {
                    // console.log(values);
                    savePeriodeKurban(values)

                }}
            >
                {({ handleSubmit, values, setFieldValue, handleChange }) => (
                    <>

                        <Modal.Body className="overlay overlay-block cursor-default">
                            {actionsLoading ? (
                                <div className="overlay-layer bg-transparent">
                                    <div className="spinner spinner-lg spinner-success" />
                                </div>
                            ) : <Form className="form form-label-right">
                                <div className="form-group row">
                                    <div className={`${id ? 'col-lg-12' : 'col-lg-6'} mb-1`}>
                                        <Field
                                            name="name"
                                            component={Input}
                                            placeholder="Text"
                                            label="Nama Periode Kurban"
                                        />
                                    </div>
                                    {!id &&
                                        <div className="col-lg-6 mb-1">
                                            <Field
                                                name="kurban_number_prefix"
                                                type="number"
                                                component={Input}
                                                placeholder="Text"
                                                label="Prefix Number Kurban (Sekali Input, Tidak Bisa Edit)"
                                            />
                                        </div>
                                    }
                                    <div className="col-lg-6 mb-1">
                                        <Field
                                            name="target_sapi"
                                            type="number"
                                            component={Input}
                                            placeholder="Text"
                                            label="Jumlah Target Sapi"
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-1">
                                        <Field
                                            name="target_fr_sapi"
                                            component={Input}
                                            placeholder="Text"
                                            label="Jumlah Target Sapi Perorang"
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-1">
                                        <Field
                                            name="target_kambing"
                                            type="number"
                                            component={Input}
                                            placeholder="Text"
                                            label="Jumlah Target Kambing"
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-1">
                                        <Field
                                            name="target_fr_kambing"
                                            component={Input}
                                            placeholder="Text"
                                            label="Jumlah Target Kambing Perorang"
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-1">
                                        <Field
                                            name="target_17_sapi"
                                            type="number"
                                            component={Input}
                                            placeholder="Text"
                                            label="Jumlah Target 1/7 Sapi"
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-1">
                                        <Field
                                            name="target_fr_17_sapi"
                                            component={Input}
                                            placeholder="Text"
                                            label="Jumlah Target 1/7 Sapi Perorang"
                                        />
                                    </div>

                                </div>

                            </Form>}

                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate"
                            >
                                Cancel
                            </button>
                            <> </>
                            <button
                                type="submit"
                                onClick={() => handleSubmit()}
                                className="btn btn-primary btn-elevate"
                            >
                                Save
                            </button>
                        </Modal.Footer>
                    </>
                )}
            </Formik>
        </>
    );
}

